import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  EditGridColumnButton,
  LiveMapDisplayModeDropdown,
  PanelTopRightWrapperStyled,
  PanelTopStatRidesLiveMap,
} from "@ryde/layout";
import {
  liveMapMobileSurfaceAtom,
  LiveMapMobileSurfaceEnum,
  useIsMobile,
} from "@ryde/shared";

import {
  LiveMapDiagnosticsAndMapPollingStyled,
  LiveMapDiagnosticsControl,
  LiveMapTopControlsGrid,
  LiveMapTopControlsMap,
  LiveMapTopWrapper,
  ViewSwitchLiveMap,
} from "./parts";

export const LiveMapTop: FC = () => {
  const { isMobile } = useIsMobile();
  const mobileSurface = useRecoilValue(liveMapMobileSurfaceAtom);

  if (isMobile) {
    const isGridSurface = mobileSurface === LiveMapMobileSurfaceEnum.Grid;

    return (
      <LiveMapTopWrapper>
        {isGridSurface && <LiveMapTopControlsGrid />}
        {!isGridSurface && (
          <>
            <LiveMapTopControlsMap />
            <LiveMapDisplayModeDropdown />
          </>
        )}
        <div className="right_stat_panel">
          <PanelTopRightWrapperStyled>
            <ViewSwitchLiveMap />
          </PanelTopRightWrapperStyled>
        </div>
      </LiveMapTopWrapper>
    );
  }

  return (
    <LiveMapTopWrapper>
      <LiveMapTopControlsGrid />
      <div className="right_stat_panel">
        <PanelTopRightWrapperStyled>
          <LiveMapDiagnosticsAndMapPollingStyled>
            <LiveMapDiagnosticsControl />
            <LiveMapTopControlsMap />
          </LiveMapDiagnosticsAndMapPollingStyled>
          <PanelTopStatRidesLiveMap />
          <LiveMapDisplayModeDropdown />
          <EditGridColumnButton />
        </PanelTopRightWrapperStyled>
      </div>
    </LiveMapTopWrapper>
  );
};
